import React from 'react'
import { notifications } from '@mantine/notifications'
import { TbCheck, TbX } from 'react-icons/tb'
import { ReactComponent as IcWarning } from '@/assets/icon/icWarning.svg'
import { Loader } from '@mantine/core'

/**
 * Shows a success notification for location operations
 */
export const showSuccessNotification = (message: string): void => {
  notifications.show({
    icon: <TbCheck color="green.4" size={16} />,
    color: 'green.4',
    autoClose: true,
    message,
    bg: 'green.1',
    withCloseButton: false,
    styles: {
      title: { color: 'var(--mantine-color-green-6)' },
      description: { color: 'var(--mantine-color-green-6)' },
      // closeButton: { color: 'var(--mantine-color-green-6)' },
      root: { border: '1px solid var(--mantine-color-green-5)' }
    }
  })
}

/**
 * Shows an error notification for location operations
 * @param message The error message to display
 */
export const showErrorNotification = (message: string = 'An error occurred'): void => {
  notifications.show({
    icon: <IcWarning width={20} height={20} />,
    message,
    withCloseButton: false,
    autoClose: 5000,
    styles: {
      root: {
        backgroundColor: '#FBF3F5',
        border: '1px solid #FF4C58',
        color: '#FF4C58',
        borderRadius: 12
      },
      description: {
        color: '#FF4C58',
        fontWeight: 500
      },
      icon: {
        backgroundColor: 'transparent',
        color: '#FF4C58',
        width: 28,
        height: 28,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        marginRight: 12
      }
    }
  })
}
